export default {
	performances: (isrc: string) => `/track/${isrc}/performances`,
	top: (isrc: string) => `/track/${isrc}/top`,
	favorites: (isrc: string) => `/track/${isrc}/favorites`,
	map: (isrc: string) => `/track/${isrc}/map`,
	demographics: (isrc: string) => `/track/${isrc}/demographics`,
	streamingContext: (isrc: string) => `/track/${isrc}/streaming-context`,
};
